module.exports = __webpack_public_path__ + "static/img/detect01.95d48cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect01.png
// module id = 575
// module chunks = 4